import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=28aa391d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=28aa391d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa391d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28aa391d')) {
      api.createRecord('28aa391d', component.options)
    } else {
      api.reload('28aa391d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=28aa391d&scoped=true&", function () {
      api.rerender('28aa391d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HhNIENO9CX6e/JS/comp/Voucher.vue"
export default component.exports